// extracted by mini-css-extract-plugin
export var dataCell = "_ox-2";
export var dataRow = "_ox-0";
export var headerRow = "_ox-1";